import { render } from "./reserveEditModel.vue?vue&type=template&id=4c8c826c"
import script from "./reserveEditModel.vue?vue&type=script&lang=js"
export * from "./reserveEditModel.vue?vue&type=script&lang=js"

import "./reserveEditModel.vue?vue&type=style&index=0&id=4c8c826c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__